var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-builder-backgroud-image px-6"},[_c('snow-input-file',{attrs:{"isImage":"","isFluid":""},on:{"input":_vm.saveBackground},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }